import { render } from "./DocViewer.vue?vue&type=template&id=a52d8a94&scoped=true"
import script from "./DocViewer.vue?vue&type=script&lang=js"
export * from "./DocViewer.vue?vue&type=script&lang=js"

import "./DocViewer.vue?vue&type=style&index=0&id=a52d8a94&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a52d8a94"]])

export default __exports__